"use client";

import { useParams } from "next/navigation";
import { useTranslations } from "next-intl";
import { FaqCategoryView } from "@/components/faq/FaqCategoryView";
import { isFaqCategoryId } from "@/components/faq/faqMeta";
import { findFaqCategoryById, parseFaqCategories } from "@/components/faq/parseFaqContent";

/**
 * FAQ category body that resolves the category from the active locale messages.
 */
export function FaqCategoryPageClient() {
  const params = useParams<{ category: string }>();
  const categoryId = typeof params.category === "string" ? params.category : "";
  const t = useTranslations("faq");

  if (!isFaqCategoryId(categoryId)) {
    return (
      <div className="gruv-faq">
        <p>FAQ no encontrado.</p>
      </div>
    );
  }

  const categories = parseFaqCategories(t.raw("categories"));
  const category = findFaqCategoryById(categories, categoryId);
  if (!category) {
    return (
      <div className="gruv-faq">
        <p>FAQ no encontrado.</p>
      </div>
    );
  }

  return <FaqCategoryView category={category} backToFaqLabel={t("backToFaq")} />;
}
